const validSlugs = [
  'N-5yc1vZzv',
  'N-5yc1vZ7n4',
  'N-5yc1vZbqlyZ7i0',
  'N-5yc1vZbm7vZ6gu',
  'N-5yc1vZ2x6',
  'N-5yc1vZcaw8Zeun',
  'N-5yc1vZbv74Zha',
  'N-5yc1vZr9s',
  'N-5yc1vZg2',
  'N-5yc1vZ3xg',
  'N-5yc1vZ1qh',
  'N-5yc1vZc213Zur',
  'N-5yc1vZ2fkpddo',
  'N-5yc1vZar0yZ3ae',
  'N-5yc1vZaqihZyq',
  'N-5yc1vZar2dZmf4',
  'N-5yc1vZar2dZ30jZ55aZfpxZftxZupm',
  'N-5yc1vZ2fkowlf',
  'N-5yc1vZc213Z1c3',
  'N-5yc1vZbm7vZ4mm',
  'N-5yc1vZc1jwZezq',
  'N-5yc1vZaq3yZ7i0',
  'N-5yc1vZ7zx',
  'N-5yc1vZcfb7Zern',
  'N-5yc1vZcfb7Z1ls',
  'N-5yc1vZbx5cZ1i9',
  'N-5yc1vZc1xyZpcz',
  'N-5yc1vZc1jwZgqn',
  'N-5yc1vZbvn5Zpoo',
  'N-5yc1vZ2fkol2aZ15b',
  'N-5yc1vZbm79Z15b',
  'N-5yc1vZbx5cZeb',
  'N-5yc1vZaripZ4qr',
  'N-5yc1vZbvn5Zh6r',
  'N-5yc1vZ3mw',
  'N-5yc1vZc1xyZ9u',
  'N-5yc1vZbqsiZ1u0',
  'N-5yc1vZ4j2',
  'N-5yc1vZc298Z4j2Z1z1aabc',
  'N-5yc1vZ1or',
  'N-5yc1vZ18g',
  'N-5yc1vZbvn5Zgfp',
  'N-5yc1vZc34hZx6',
  'N-5yc1vZc7c8Z15b',
  'N-5yc1vZar2dZgk6',
  'N-5yc1vZm5d',
  'N-5yc1vZyg',
  'N-5yc1vZbqsiZixr',
  'N-5yc1vZbv74Zbxz',
  'N-5yc1vZaqihZ5o',
  'N-5yc1vZ3r4',
  'N-5yc1vZbmgbZua',
  'N-5yc1vZbv1wZne6',
  'N-5yc1vZbv1wZz2',
  'N-5yc1vZbvlqZra',
  'N-5yc1vZbv1wZ4l4',
  'N-5yc1vZbv1wZ9u',
  'N-5yc1vZ2fkpa8z',
  'N-5yc1vZbv1wZ8qk',
  'N-5yc1vZcaw8',
  'N-5yc1vZaq7m',
  'N-5yc1vZcfj3',
  'N-5yc1vZchnc',
  'N-5yc1vZbx62',
  'N-5yc1vZc4md',
  'N-5yc1vZckb3',
  'N-5yc1vZcalg',
  'N-5yc1vZc4kl',
  'N-5yc1vZc6ge',
  'N-5yc1vZc5aw',
  'N-5yc1vZc4m6',
  'N-5yc1vZc6g3',
  'N-5yc1vZc6g4',
  'N-5yc1vZc89g',
  'N-5yc1vZc7nn',
  'N-5yc1vZchd3',
  'N-5yc1vZchcx',
  'N-5yc1vZchcy',
  'N-5yc1vZcibv',
  'N-5yc1vZaro4',
  'N-5yc1vZc7qe',
  'N-5yc1vZc8hv',
  'N-5yc1vZard1',
  'N-5yc1vZc266',
  'N-5yc1vZc8lf',
  'N-5yc1vZcfiv',
  'N-5yc1vZ2fkp9sf',
  'N-5yc1vZ1z1wkrz',
  'N-5yc1vZc22a',
  'N-5yc1vZ2fkpcfz',
  'N-5yc1vZb97i',
  'N-5yc1vZb97t',
  'N-5yc1vZchd7',
  'N-5yc1vZchcw',
  'N-5yc1vZc6nx',
  'N-5yc1vZcall',
  'N-5yc1vZcl2t',
  'N-5yc1vZcljk',
  'N-5yc1vZc3hb',
  'N-5yc1vZc2bd',
  'N-5yc1vZcdrk',
  'N-5yc1vZc7ps',
  'N-5yc1vZbqld',
  'N-5yc1vZc5ap',
  'N-5yc1vZc71x',
  'N-5yc1vZbv1z',
  'N-5yc1vZ2fkp9hc',
  'N-5yc1vZ2fkp9hd',
  'N-5yc1vZ2fkp9h9',
  'N-5yc1vZ2fkp9ha',
  'N-5yc1vZcldr',
  'N-5yc1vZc9xk',
  'N-5yc1vZcbj5',
  'N-5yc1vZcbjc',
  'N-5yc1vZcbjj',
  'N-5yc1vZcbjp',
  'N-5yc1vZ2fkor2u',
  'N-5yc1vZcbjf',
  'N-5yc1vZcbji',
  'N-5yc1vZclep',
  'N-5yc1vZclg3',
  'N-5yc1vZc419',
  'N-5yc1vZcex1',
  'N-5yc1vZas6pZ7',
  'N-5yc1vZci03',
  'N-5yc1vZbx5c',
  'N-5yc1vZ2fkpd5l',
  'N-5yc1vZc5ah',
  'N-5yc1vZc7c9',
  'N-5yc1vZcdtx',
  'N-5yc1vZbt0h',
  'N-5yc1vZarlz',
  'N-5yc1vZchna',
  'N-5yc1vZchd4',
  'N-5yc1vZcbb8',
  'N-5yc1vZcbbb',
  'N-5yc1vZbt0v',
  'N-5yc1vZbt0w',
  'N-5yc1vZasen',
  'N-5yc1vZaqet',
  'N-5yc1vZ2fkojw4',
  'N-5yc1vZbobk',
  'N-5yc1vZbbbj',
  'N-5yc1vZci1c',
  'N-5yc1vZbd1j',
  'N-5yc1vZarth',
  'N-5yc1vZ1z18gzk',
  'N-5yc1vZaqfm',
  'N-5yc1vZc23l',
  'N-5yc1vZ1z18gwb',
  'N-5yc1vZbtz1',
  'N-5yc1vZbx5cZ7',
  'N-5yc1vZchn8',
  'N-5yc1vZcfyt',
  'N-5yc1vZcfz1',
  'N-5yc1vZch3g',
  'N-5yc1vZbrdj',
  'N-5yc1vZcjob',
  'N-5yc1vZcbn2',
  'N-5yc1vZcfvmZ7',
  'N-5yc1vZbx4oZ7',
  'N-5yc1vZc69u',
  'N-5yc1vZchn9',
  'N-5yc1vZchnl',
  'N-5yc1vZc8s2',
  'N-5yc1vZcfck',
  'N-5yc1vZcfcn',
  'N-5yc1vZbx76',
  'N-5yc1vZcfcr',
  'N-5yc1vZc27l',
  'N-5yc1vZc28z',
  'N-5yc1vZc29n',
  'N-5yc1vZc2gr',
  'N-5yc1vZc26w',
  'N-5yc1vZc276',
  'N-5yc1vZc29zZ1z1dqgv',
  'N-5yc1vZc2a3',
  'N-5yc1vZc2dn',
  'N-5yc1vZc2el',
  'N-5yc1vZbm2w',
  'N-5yc1vZbm30',
  'N-5yc1vZbohk',
  'N-5yc1vZc33w',
  'N-5yc1vZc1jwZezq',
  'N-5yc1vZcf5m',
  'N-5yc1vZc4lv',
  'N-5yc1vZc3pe',
  'N-5yc1vZc359',
  'N-5yc1vZapvr',
  'N-5yc1vZas5u',
  'N-5yc1vZceyp',
  'N-5yc1vZc1kd',
  'N-5yc1vZc1ku',
  'N-5yc1vZ2fkp36v',
  'N-5yc1vZc3pv',
  'N-5yc1vZcexg',
  'N-5yc1vZasco'
];
export const validateSlug = (slug) => {
  return validSlugs.includes(slug);
};
